import React from 'react';
import { motion } from 'framer-motion';
import { lookbook } from '../data';

export default function Lookbook() {
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="pt-32 md:pt-40 px-6 container mx-auto pb-24"
    >
      <header className="mb-20 md:mb-32 text-center border-b border-graphite/20 pb-12 md:pb-16 max-w-4xl mx-auto">
        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-fluid-h2"
        >
          EDITORIAL <span className="text-crimson mx-2">///</span> VOL. 1
        </motion.h1>
      </header>
      
      <div className="space-y-32 md:space-y-48">
        {lookbook.map((look, index) => (
          <div key={look.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 lg:gap-24 items-center`}>
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="w-full lg:w-3/5 aspect-[4/5] lg:aspect-[16/10] overflow-hidden bg-bone"
            >
              <img src={look.image} alt={look.title} className="w-full h-full object-cover" />
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="w-full lg:w-2/5 md:px-8"
            >
              <h2 className="text-3xl md:text-5xl tracking-tighter mb-8 md:mb-12 leading-none">{look.title}</h2>
              <div className="space-y-6">
                <p className="text-xs uppercase tracking-widest text-crimson font-bold">Featured Garments</p>
                <ul className="space-y-4 border-l-2 border-graphite/20 pl-6">
                  {look.items.map((item, i) => (
                    <li key={i} className="text-lg md:text-xl font-medium tracking-tight text-graphite/80">{item}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}